var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn--lg btn--green-inv",attrs:{"type":"button"},on:{"click":_vm.showCatalog}},[(_vm.$store.state._overlays.showCatalog)?_c('RemixIconComponent',{attrs:{"category":"System","name":"close-line"}}):_c('RemixIconComponent',{attrs:{"category":"System","name":"menu-line"}}),_c('span',[_vm._v("Каталог товаров")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }